module.exports = __webpack_public_path__ + "static/media/GoGoals.dfe1c0e0.jpeg";